export default "__VITE_ASSET__BN37ZJbw__"